<template>
    <div>
        <van-nav-bar ref="nav" title="编辑个人资料" right-text="保存" left-arrow @click-left="closePage"
            @click-right="onClickSave" />
        <van-pull-refresh v-model="isLoading" @refresh="onRefreshPage">
            <div class="container">
                <div class="avatar">
                    <div class="avatar-box">
                        <van-image :src="headImg"></van-image>
                        <!-- <img :src="headImg" alt="" /> -->
                    </div>
                    <div class="edit" @click="headImgShow = true">编辑头像</div>
                    <van-popup v-model="headImgShow" round position="bottom" class="head-img-box">
                        <div class="option">
                            <p class="cancel" @click="onImgPopCancel">取消</p>
                            <p class="op">选择头像</p>
                            <p class="save" @click="onImgPopSave">保存</p>
                        </div>
                        <div class="img-select">
                            <van-image :src="selectedAvatar"/>
                        </div>
                        <div class="line"></div>
                        <div class="avatar-system">
                            <p class="avatar-tit">系统头像</p>
                            <div class="imgs">
                                <van-image v-for="item in headImgList" :src="item.default_url"
                                    @click="selectAvatar(item.default_url)" alt="" />
                            </div>
                            <p v-if="!reviewAvatar" class="avatar-self">
                                自拟定头像<span>（审核通过后自动更新，仅支持png、jpg、gif格式）</span>
                            </p>
                            <van-uploader v-if="!reviewAvatar" style="margin-bottom: 4.5rem" v-model="fileList"
                                :after-read="afterRead" :max-count="1">
                                <van-button icon="plus" style="width: 2.35rem;height: 2.35rem;background-color: #e4e4e4;color: #656565;"></van-button>
                            </van-uploader>
                            <p v-if="reviewAvatar" class="avatar-self">
                                待审核头像<span>（审核通过后自动更新，仅支持png、jpg、gif格式）</span>
                            </p>
                            <div v-if="reviewAvatar" style="width: 2.3rem; height: 2.3rem; margin-bottom: 4.5rem">
                                <img width="100%" height="100%" :src="reviewAvatar" alt="待审核" />
                            </div>
                        </div>
                    </van-popup>
                </div>
                <div class="form">
                    <p class="txt">昵称</p>
                    <input class="info nickname" @input="nickChangeHandle" v-model="nickname" type="text"
                        maxlength="8" />
                    <p class="txt">性别</p>
                    <input class="info gender" v-model="gender" readonly placeholder="请选择性别" type="text"
                        @click="genderShow = true" />
                    <van-popup v-model="genderShow" round position="bottom" class="genbox">
                        <div class="space"></div>
                        <div class="option">
                            <p class="cancel" @click="genderShow = false">取消</p>
                            <p class="op">请选择您的性别</p>
                            <p class="save" @click="onSave">保存</p>
                        </div>

                        <div class="gender-option-box" v-for="gender in genders" :key="gender.id"
                            :class="{ selected: selectedGenderId === gender.id }"
                            @click="selectGender(gender.id, gender.name)">
                            <div class="gender-name">
                                <img v-if="gender.id == '1'" src="../../assets/user/man.png" alt=""
                                    style="margin-right: 0.65rem" />
                                <img v-if="gender.id == '2'" src="../../assets/user/woman.png" alt=""
                                    style="margin-right: 0.5rem" />
                                <span>{{ gender.name }}</span>
                            </div>
                        </div>
                    </van-popup>
                    <p class="txt">生日</p>
                    <input class="info birth" v-model="birth" readonly placeholder="未选择" type="text"
                        @click="birthShow = true" />
                    <van-popup v-model="birthShow" round position="bottom" class="birthbox">
                        <div class="space"></div>
                        <van-datetime-picker v-model="currentDate" type="date" title="请选择您的破壳日" confirm-button-text="保存"
                            item-height="1.75rem" :min-date="minDate" :max-date="maxDate" :formatter="formatter"
                            @cancel="onBirthCancel" @confirm="onBirthSave" />
                    </van-popup>
                    <p class="txt">个人签名</p>
                    <input class="info sign" v-model="sign" @input="checkInputLength" placeholder="输入您的签名不超过20字"
                        type="text" />
                    <p class="tips">
                        温馨提示： 昵称每月每个用户仅有一次修改机会，请谨慎使用
                    </p>
                </div>
            </div>
        </van-pull-refresh>
    </div>
</template>
<script>
    import {
        httpRequest
    } from "@/ajax";
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                headImgShow: false,
                genderShow: false,
                birthShow: false,
                nickname: "",
                //昵称是否发生改变
                isNicknameChange: false,
                gender: "",
                //主页头像
                headImg: "",
                //选择头像弹框内展示当前点击的头像
                selectedAvatar: "",
                //待审核头像
                reviewAvatar: "",
                //自拟定头像
                customAvatar: "",
                //存储当前选中性别的id、name
                selectedGenderId: null,
                selectedGenderName: "",
                genders: [{
                        id: "1",
                        name: "男"
                    },
                    {
                        id: "2",
                        name: "女"
                    },
                ],
                birth: '',
                minDate: new Date(1970, 1, 1),
                maxDate: new Date(),
                currentDate: new Date(),
                sign: "",
                maxLength: 20,
                headImgList: [],
                fileList: [],
                //内容是否发生改变
                isContentChange: false,
            };
        },
        watch: {
            headImgShow(newValue) {
                if (!newValue) {
                    this.selectedAvatar = this.headImg;
                }
            },
        },
        created() {},
        mounted() {
            this.getUserInfoAPI1();
            this.getUserInfoAPI2();
            this.getHeadListAPI();
        },
        methods: {
            onRefreshPage() {
                var that = this
                setTimeout(() => {
                    that.getUserInfoAPI1();
                    that.getUserInfoAPI2();
                    that.getHeadListAPI();
                  that.isLoading = false;
                }, 1000);
            },
            //内容修改时改变保存按钮颜色
            inputChangeHandle() {
                this.isContentChange = true;
                const div = this.$refs.nav.$el;
                const paragraphs = div.getElementsByClassName("van-nav-bar__text");
                paragraphs[0].style.color = "#670000";
            },
            afterRead(file) {
                var that = this
                // 此时可以自行将文件上传至服务器
                httpRequest("/com/upload-img", file.file).then(res => {
                    if(res.data.code == 200) {
                        that.reviewAvatar = that.customAvatar = res.data.data.url;
                        that.$toast(res.data.msg)
                    }
                });
            },
            nickChangeHandle() {
                this.isNicknameChange = true;
                this.inputChangeHandle();
            },
            //签名不能超过20字
            checkInputLength() {
                this.inputChangeHandle();
                if (this.sign.length > this.maxLength) {
                    this.sign = this.sign.slice(0, this.maxLength);
                }
            },
            //当前选择的性别
            selectGender(genderId, genderName) {
                this.selectedGenderId = genderId;
                this.selectedGenderName = genderName;
                //   console.log(this.selectedGenderId, this.selectedGenderName);
            },
            //性别保存
            onSave() {
                this.inputChangeHandle();
                this.gender = this.selectedGenderName;
                this.genderShow = false;
            },
            formatter(type, val) {
                if (type === "year") {
                    return val + "年";
                }
                if (type === "month") {
                    return val + "月";
                }
                if (type === "day") {
                    return val + "日";
                }
                return val;
            },
            onBirthCancel() {
                this.birthShow = false;
            },
            onBirthSave(value) {
                this.inputChangeHandle();
                //转换打印出年月日为所需格式
                const date = new Date(value);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const formattedDate = `${year}-${month}-${day}`;
                this.birth = formattedDate;
                this.birthShow = false;
            },
            getUserInfoAPI1() {
                this.$Ajax("/user/userinfo", {}).then((res) => {
                    this.headImg = res.data.head_img;
                    this.selectedAvatar = res.data.head_img;
                    this.nickname = res.data.nick_name;
                    if (res.data.birthday == '0000-00-00') {
                        this.birth = "1990-10-01";
                    } else {
                        this.birth = res.data.birthday;
                    }

                    this.gender = res.data.sex == "1" ? "男" : "女";
                    this.selectedGenderId = res.data.sex;
                    this.currentDate = new Date(this.birth.split("-").map(Number));
                });
            },
            getUserInfoAPI2() {
                this.$Ajax("/my/user-center", {}).then((res) => {
                    this.sign = res.data.userDsc;
                });
            },
            // 获取头像列表
            getHeadListAPI() {
                this.$Ajax("my/head-list", {}).then((res) => {
                    this.headImgList = res.data.list;
                    this.reviewAvatar = res.data.reviewAvatar ? res.data.reviewAvatar.avatar : ''
                });
            },

            //点击展示当前选择头像
            selectAvatar(url) {
                this.selectedAvatar = url;
            },
            //关闭头像选择弹框触发
            onImgPopCancel() {
                this.headImgShow = false;
            },
            //保存头像选择弹框触发
            onImgPopSave() {
                this.$Ajax('my/save-user-avatar',{
                    avatar: this.reviewAvatar,
                    headImg: this.selectedAvatar
                }).then(rs => {
                    if(rs.code == 200) {
                        this.$toast(rs.msg)
                        this.headImg = this.selectedAvatar;
                        this.headImgShow = false;
                    }
                })
            },
            //保存成功后重置保存按钮，按钮颜色恢复,且内容判断变为未修改状态
            saveSuccessBtn() {
                this.isContentChange = false;
                const div = this.$refs.nav.$el;
                const paragraphs = div.getElementsByClassName("van-nav-bar__text");
                paragraphs[0].style.color = "#9e9e9e";
            },
            //页面保存时触发
            onClickSave() {
                //修改/新增
                if (this.isContentChange) {
                    this.saveSuccessBtn(); //重置保存按钮
                    if (this.isNicknameChange) {
                        if (this.nickname == '') {
                            this.$toast('昵称不能未空')
                        }
                        this.$Ajax("my/save-user-data", {
                            nickName: this.nickname,
                            birthday: this.birth,
                            sex: this.selectedGenderId,
                        }).then((res) => {
                            if (res.code == 200) {
                                this.$Ajax("/my/user-sign", {
                                    userSign: this.sign
                                }).then(
                                    (res) => {
                                        if (res.code == 200) {
                                            this.getUserInfoAPI1();
                                            this.getUserInfoAPI2();
                                            if (this.nickname != '') {
                                                this.$toast({
                                                    message: '修改成功',
                                                    onClose: () => {
                                                        this.closePage()
                                                    }
                                                })
                                            }
                                        }
                                    }
                                );
                            }
                        });
                        this.isNicknameChange = false; //重置昵称修改状态
                    } else {
                        if (this.nickname == '') {
                            this.$toast('昵称不能未空')
                        }
                        this.$Ajax("my/save-user-data", {
                            birthday: this.birth,
                            sex: this.selectedGenderId,
                        }).then(() => {
                            this.$Ajax("/my/user-sign", {
                                userSign: this.sign
                            }).then((res) => {
                                if (res.code == 200) {
                                    this.getUserInfoAPI1();
                                    this.getUserInfoAPI2();
                                    if (this.nickname != '') {
                                        this.$toast({
                                            message: '修改成功',
                                            onClose: () => {
                                                this.closePage()
                                            }
                                        })
                                    }
                                }
                            });
                        });
                    }

                } else {
                    //this.$toast("当前内容未修改");
                }
            },
        },
    };
</script>
<style lang="less" scoped>
    /deep/.van-nav-bar__right {
        &:active {
            opacity: 1;
        }
    }

    .container {
        margin-top: 2.5rem;
        background-color: #fff;
        min-height: calc(var(--vh, 1)*100 - 2.5rem);
    }

    .avatar {

        padding-top: 1.25rem;
        padding-bottom: 1.75rem;
        background-color: #f3f2f2;

        .avatar-box {
            width: 4.55rem;
            margin: 0 auto;
            height: 4.55rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .van-image {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                border: 0.05rem solid #e4e4e4;
                overflow: hidden;
            }
        }

        .edit {
            color: #9e9e9e;
            margin: 0.75rem auto 0;
            width: 5.25rem;
            height: 1.45rem;
            border: 0.05rem #9e9e9e solid;
            border-radius: 1rem;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }

        .head-img-box {
            padding: 0.75rem;

            .option {
                display: flex;
                justify-content: space-between;
                padding: 0 0.75rem 0;
                margin-bottom: 1.75rem;

                .cancel {
                    color: #9e9e9e;
                }

                .op {
                    color: #000000;
                    font-size: 0.8rem;
                    font-weight: bold;
                }

                .save {
                    color: #670000;
                }
            }

            .img-select {
                margin: 1.8rem auto 1.75rem;
                width: 4.55rem;
                height: 4.55rem;

                .van-image {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    border: 0.05rem solid #e4e4e4;
                    overflow: hidden;
                }
            }

            .line {
                width: 100%;
                height: 0.05rem;
                background-color: #e4e4e4;
                margin-bottom: 1.25rem;
            }

            .avatar-system {
                .avatar-tit {
                    color: #000000;
                    font-weight: bold;
                    margin-bottom: 0.55rem;
                }

                .imgs {
                    display: grid;
                    grid-template-columns: repeat(6, 1fr);
                    gap: 0.6rem;
                    .van-image {
                        width: 2.3rem;
                        height: 2.3rem;
                        border-radius: 50%;
                        overflow: hidden;
                    }
                }

                .avatar-self {
                    color: #000000;
                    font-weight: bold;
                    margin: 1.25rem 0;

                    span {
                        color: #9e9e9e;
                        font-size: 0.5rem;
                        font-weight: normal;
                        margin-left: 0.4rem;
                    }
                }

                .van-icon-plus:before {
                    color: #656565;
                }

                :deep(.van-uploader__preview) {
                    margin: 0;

                    .van-uploader__preview-image {
                        width: 2.3rem;
                        height: 2.3rem;
                    }
                }
            }
        }
    }

    .form {
        padding: 1.15rem 0.75rem 0;
        flex: 1;
        background-color: #ffffff;

        .txt {
            color: #656565;
            font-size: 0.6rem;
        }

        .info {
            border: none;
            border-bottom: 0.05rem solid #e4e4e4;
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            width: 100%;
            color: #000000;
            margin-bottom: 1.05rem;
        }

        .info::placeholder {
            color: #e4e4e4;
        }

        .sign {
            margin-bottom: 0.4rem;
        }

        .tips {
            font-size: 0.6rem;
            color: #670000;
            opacity: 0.7;
        }

        .genbox {
            padding-bottom: 2.5rem;
        }

        .birthbox {
            padding-bottom: 1.75rem;

            :deep(.van-picker__columns) {
                padding: 0 3.5rem;
            }
        }

        .space {
            margin: 0.65rem 8.6rem 0.9rem;
            height: 0.2rem;
            border-radius: 1rem;
            background-color: #e4e4e4;
        }

        .option {
            display: flex;
            justify-content: space-between;
            padding: 0 0.75rem 0;
            margin-bottom: 1.75rem;

            .cancel {
                color: #9e9e9e;
            }

            .op {
                color: #000000;
                font-size: 0.8rem;
                font-weight: bold;
            }

            .save {
                color: #670000;
            }
        }

        .gender-option-box {
            margin: 0 0.35rem 0.35rem;
            height: 1.75rem;
            border-radius: 0.4rem;

            .gender-name {
                line-height: 1.75rem;
                padding-left: 0.45rem;
                display: flex;
                align-items: center;
            }
        }

        .selected {
            background-color: #f4f4f4;
        }

        :deep(.van-picker__toolbar) {
            align-items: flex-start;

            .van-picker__title {
                color: #000000;
                font-weight: bold;
            }

            .van-picker__cancel {
                height: 0;
                color: #9e9e9e;
            }

            .van-picker__confirm {
                height: 0;
                color: #670000;
            }
        }
    }
</style>